import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentMethodCard = ({ method, onEdit, onDelete, onSetDefault }) => {
  const getMethodIcon = (type) => {
    switch (type) {
      case 'bank':
        return 'Building2';
      case 'card':
        return 'CreditCard';
      case 'wallet':
        return 'Wallet';
      default:
        return 'DollarSign';
    }
  };

  const maskAccountNumber = (number) => {
    if (!number) return '';
    return `****${number?.slice(-4)}`;
  };

  return (
    <div className="p-4 bg-card border border-border rounded-lg hover:shadow-elevation-1 transition-smooth">
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
          method?.isDefault ? 'bg-primary/10' : 'bg-muted'
        }`}>
          <Icon 
            name={getMethodIcon(method?.type)} 
            size={20}
            color={method?.isDefault ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h3 className="font-semibold text-foreground">{method?.name}</h3>
              <p className="text-sm text-muted-foreground">{method?.bankName}</p>
            </div>
            {method?.isDefault && (
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                Varsayılan
              </span>
            )}
          </div>

          <div className="space-y-1 mb-3">
            <p className="text-sm text-muted-foreground">
              {method?.type === 'bank' ? 'IBAN: ' : 'Kart: '}
              {maskAccountNumber(method?.accountNumber)}
            </p>
            {method?.holderName && (
              <p className="text-sm text-muted-foreground">
                Hesap Sahibi: {method?.holderName}
              </p>
            )}
          </div>

          <div className="flex gap-2">
            {!method?.isDefault && (
              <Button
                variant="outline"
                size="xs"
                onClick={() => onSetDefault(method)}
              >
                Varsayılan Yap
              </Button>
            )}
            <Button
              variant="ghost"
              size="xs"
              iconName="Edit2"
              onClick={() => onEdit(method)}
            >
              Düzenle
            </Button>
            <Button
              variant="ghost"
              size="xs"
              iconName="Trash2"
              onClick={() => onDelete(method)}
              className="text-error hover:text-error"
            >
              Sil
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodCard;